import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const entities_list = useRef(null);
	const clients_list = useRef(null);
	const departamentos_list = useRef(null);

	const occurrence_type = useRef(null);
	const occurrence_origin = useRef(null);
	const storage_type = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const [files_image, set_files_image] = useState([]);
	const [, set_image_base64] = useState([])

	const [img_loader, set_img_loader] = useState([])

	const [treeDataPDF, setTreeDataPDF] = useState([])	
	const [treeDataEditable, setTreeDataEditable] = useState([])	
	const [treeDataImage, setTreeDataImage] = useState([])	
	
	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);
	const [files_doc_image, set_files_doc_image] = useState([]);
	const [files_doc_image_name, set_files_doc_image_name] = useState([]);
	
	const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [occurrence_state_edit, set_occurrence_state_edit] = useState(false)
	const [occurrence_state_aprove, set_occurrence_state_aprove] = useState(false)
	const [occurrence_state_remove, set_occurrence_state_remove] = useState(false)

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt('1'))
			
			let res_clients = clients_list.current = res.data.filter(el => parseInt(el.entity_type) === parseInt('2'))
			if (res_clients.length > 0) {
				res_clients = order_array(res_clients)

				let res_aux_clients = []
				for await (let el of res_clients) {
					res_aux_clients.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(clients_list.current = res_aux_clients)
			}
			set_dados()
		}

		return result

	}

	const fetch_quality_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}/active`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {

				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt')
				}

				result.push(aux)
			}
		}

		return result

	}

	const fetch_departments = async () => {

		let res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {


				console.log('el', el)

				let aux = {
					id: el.id,
					name: el.info.name
				}

				result.push(aux)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))
		
		set_dados(entities_list.current = [])
		set_dados(occurrence_type.current = [])
		set_dados(occurrence_origin.current = [])
		set_dados(storage_type.current = [])
		set_dados(departamentos_list.current = [])

		const get_attr = async () => {

			let res_1 = await fetch_quality_attributes('occurrence_type')
			if (res_1.length > 0) {
				res_1 = order_array(res_1)

				let res_aux_1 = []
				for await (let el of res_1) {
					res_aux_1.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(occurrence_type.current = res_aux_1)
			}
			let res_2 = await fetch_quality_attributes('occurrence_origin')
			if (res_2.length > 0) {
				res_2 = order_array(res_2)

				let res_aux_2 = []
				for await (let el of res_2) {
					res_aux_2.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(occurrence_origin.current = res_aux_2)
			}
			let res_4 = await fetch_entities_list()
			if (res_4.length > 0) {
				res_4 = order_array(res_4)

				let res_aux_4 = []
				for await (let el of res_4) {
					res_aux_4.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(entities_list.current = res_aux_4)
			}
			let res_5 = await fetch_departments()
			if (res_5.length > 0) {
				res_5 = order_array(res_5)

				let res_aux_5 = []
				for await (let el of res_5) {
					res_aux_5.push({
						id: el.id,
						label: el.name
					})
				}
				set_dados(departamentos_list.current = res_aux_5)

				console.log('res_5', res_5)

			}

			setLoading(false);

			return true

		}

		const fetch_id_info = async (id_serch) => {
			
			try {

				let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
				set_dados(dados.current = res.data[0]);

				if(Array.isArray(res.data) && res.data.length > 0) {
					if(res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
						let aux_doc_pdf = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf) {
							if (aux_doc_pdf[0] === undefined)
								aux_doc_pdf[0] = []
							if (aux_doc_pdf[0][1] === undefined)
								aux_doc_pdf[0][1] = []

							// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDF(aux_doc_pdf)
					} 
					if(res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
						let aux_doc_editable = []
						let i = 0

						for await (let el of res.data[0].info.file.editable) {
							if (aux_doc_editable[0] === undefined)
								aux_doc_editable[0] = []
							if (aux_doc_editable[0][1] === undefined)
								aux_doc_editable[0][1] = []

							// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataEditable(aux_doc_editable)
					} 
					if(res.data[0]?.info?.file?.file_image !== undefined && Array.isArray(res.data[0].info.file.file_image)) {
						let aux_doc_image = []
						let i = 0

						for await (let el of res.data[0].info.file.file_image) {
							if (aux_doc_image[0] === undefined)
								aux_doc_image[0] = []
							if (aux_doc_image[0][1] === undefined)
								aux_doc_image[0][1] = []

							aux_doc_image[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							// aux_doc_image[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataImage(aux_doc_image)
					} 
				} 

				set_is_edit(true)

				get_attr()
				
			} catch (error) {
				console.error("Erro:", error);
			}
		}
		try {
			let test = props.location.state.operation;
		
			if (test === 'edit') {
				fetch_id_info(props.location.state.item.id)
			}
			else {
				set_dados(dados.current.info.number = parseInt(props.location.state.item['number']) + 1)

				get_attr()
			}

		} catch {
			clean_data()

			set_dados(dados.current.info.number = parseInt(props.location.state.item['number']) + 1)

			get_attr()

			return
		}

	}, [props]);

	const handleSubmit = async e => {
		e.preventDefault();

		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then(async (result) => {
				if (result.isConfirmed) {
					if(occurrence_state_aprove) {
						dados.current.info.settings.occurrence_state = "3"

						dados.current.info.responsable.aproval.execution = today
						dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
					}

					if(notify_responsable_edit) {
						if(dados.current.info.responsable.edit.id !== '') {
							let aux_id = dados.current.info.responsable.edit.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.edit.notification = today
							dados.current.info.responsable.edit.execution = today

							if(dados.current.info.historic === undefined || dados.current.info.historic === null) {
								dados.current.info.historic = []
							}

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
								dados.current.info.historic.push({
									edit: {
										id: aux_responsable[0].id,
										name: aux_responsable[0].label,
										date: today
									},
									aproval: {
										id: '',
										name: '',
										date: ''
									}
								})

								dados.current.info.responsable.aproval.id = ''
								dados.current.info.responsable.aproval.name = ''
								dados.current.info.responsable.aproval.notification = ''
								dados.current.info.responsable.aproval.execution = ''
							}
							else {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								if(aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
								}
								else {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})
									
									dados.current.info.settings.occurrence_state = "1"

									dados.current.info.responsable.aproval.id = ''
									dados.current.info.responsable.aproval.name = ''
									dados.current.info.responsable.aproval.notification = ''
									dados.current.info.responsable.aproval.execution = ''
								} 
							}
						}
					}

					if(notify_responsable_aproval) {
						if(dados.current.info.responsable.aproval.id !== '') {
							let aux_id = dados.current.info.responsable.aproval.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.aproval.notification = today

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

							}
						}
					}

					if(notify_responsable_remove) {
						if(dados.current.info.responsable.remove.id !== '') {

							dados.current.info.responsable.remove.notification = today
							dados.current.info.responsable.remove.execution = today

						}

					}

					for await (let el_doc of files_doc_pdf) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_pdf([])
					set_files_doc_pdf_name([])

					for await (let el_doc of files_doc_editable) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_editable([])
					set_files_doc_editable_name([])

					for await (let el_doc of files_doc_image) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'file_image', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_image([])
					set_files_doc_image_name([])

					await reqPUT(api_crud_route, dados.current)
						.then(async () => { 
							if(notify_responsable_edit) {

							}
							if(notify_responsable_aproval) {
								if(dados.current.info.responsable.aproval.id !== '') {

									let aux_id = dados.current.info.responsable.aproval.id
									let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

									if(Array.isArray(aux_responsable) && aux_responsable.length > 0) {

										let aux = {
											id: dados.current.id,
											uniqid: dados.current.info.uniqid,
											companycode: dados.current.info.companycode,

											type: 'occurrence',
											title: translate(dados.current.info.title, lang),
											description: translate(dados.current.info.description, lang),
											responsaveis: [{
												value: aux_responsable[0].id
											}],
											state_object: {
												value: 1,
												labelEn: "Pending approval",
												labelPt: "Pendente de aprovação"
											},
											deadline: '',
										}

										return

										reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

										let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
											'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
													'<div>' +
														'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
													'</div>' +
												'</td>' + 
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
													'<div>'+
														'<span>'+ today_aux + '</span>'+
													'</div>'+
												'</td>' +
											'</tr>' +
			
											'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
											'</tr>' +

											'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
													'<div>'+
														'<br/>'+
														'<span>' + language[lang].notification_aproval_text + '</span>'+
														'<br/>'+
													'</div>'+
												'</td>' +
											'</tr>' +
										'</table>'

										// let sendFrom = 'web.dev@assec.pt'
										// let sendTo = ['web.teste@assec.pt']
										// let sendToCC = ['web.dev@assec.pt']
										// let subject = language[lang].notification_aproval_subject
										// let content = mail_content
										// let attachment = []

										// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
									}
								
								}
							}
							if(notify_responsable_remove) {
								if(dados.current.info.responsable.remove.id !== '') {
									// let aux_id = dados.current.info.responsable.remove.id
									// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

									// console.log('remove aux_responsable', aux_responsable)
									dados.current.info.responsable.remove.notification = today
								}
							}

						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} 
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then(async (result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					if(occurrence_state_aprove) {
						dados.current.info.settings.occurrence_state = "3"

						dados.current.info.responsable.aproval.execution = today
						dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
					}

					if(notify_responsable_edit) {
						if(dados.current.info.responsable.edit.id !== '') {
							let aux_id = dados.current.info.responsable.edit.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.edit.notification = today
							dados.current.info.responsable.edit.execution = today

							if(dados.current.info.historic === undefined || dados.current.info.historic === null) {
								dados.current.info.historic = []
							}

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
								dados.current.info.historic.push({
									edit: {
										id: aux_responsable[0].id,
										name: aux_responsable[0].label,
										date: today
									},
									aproval: {
										id: '',
										name: '',
										date: ''
									}
								})

								// dados.current.info.responsable.aproval.id = ''
								// dados.current.info.responsable.aproval.name = ''
								// dados.current.info.responsable.aproval.notification = ''
								// dados.current.info.responsable.aproval.execution = ''
							}
							else {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								if(aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
								}
								else {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})
									
									dados.current.info.settings.occurrence_state = "1"

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								} 
							}
						}
					}

					if(notify_responsable_aproval) {
						if(dados.current.info.responsable.aproval.id !== '') {
							let aux_id = dados.current.info.responsable.aproval.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.aproval.notification = today

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

							}
						}
					}

					if(notify_responsable_remove) {
						if(dados.current.info.responsable.remove.id !== '') {

							dados.current.info.responsable.remove.notification = today
							dados.current.info.responsable.remove.execution = today

						}

					}

					for await (let el_doc of files_doc_pdf) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_pdf([])
					set_files_doc_pdf_name([])

					for await (let el_doc of files_doc_editable) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_editable([])
					set_files_doc_editable_name([])

					for await (let el_doc of files_doc_image) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'file_image', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_image([])
					set_files_doc_image_name([])

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if(name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if(aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if(el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		dados.current.info[name] = value

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

		
	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if(dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if(aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if(el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if(name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	
	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {
		
		set_occurrence_state_aprove(!occurrence_state_aprove)

	}

	const change_occurrence_settings = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.settings === undefined) {
			dados.current.info.settings = {}
		}

		set_dados(dados.current.info.settings[name] = value)

		console.log('dados.current.info.settings', dados.current.info.settings)

	}

	const change_occurrence_responsable = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		if(name === 'edit') {
			set_notify_responsable_edit(true)
		}
		else if(name === 'aproval') {
			set_notify_responsable_aproval(true)
		}
		else if(name === 'remove') {
			set_notify_responsable_remove(true)
		}

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: '',
			execution:	''
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			console.log(aux_entity[0])
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.responsable[name] = aux)

		console.log('dados.current.info.responsable', dados.current.info.responsable)

	}

	const change_occurrence_action = (e) => {
		const { name, value, dataset } = e.target;
		const { type } = dataset


		console.log('value', value)

		if (dados.current.info.action === undefined) {
			dados.current.info.action = {}
		}
		if (dados.current.info.action[type] === undefined) {
			dados.current.info.action[type] = {}
		}

		set_dados(dados.current.info.action[type][name] = value)

		console.log('dados.current.info.action', dados.current.info.action)

	}

	const change_occurrence_action_date = (e) => {
		const { name, value, dataset } = e.target;
		const { type, type2 } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = {}
		}
		if (dados.current.info.action[type] === undefined) {
			dados.current.info.action[type] = {}
		}
		if (dados.current.info.action[type][name] === undefined) {
			dados.current.info.action[type][name] = {}
		}

		set_dados(dados.current.info.action[type][name]['notification'] = new Date(value).toJSON())
		if(type2 !== '') {
			set_dados(dados.current.info.action[type][name][type2] = new Date(value).toJSON())
		}

		console.log('dados.current.info.action', dados.current.info.action)

	}
	
	const change_occurrence_action_responsable = (e) => {
		const { name, value, dataset } = e.target;
		const { type } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = {}
		}
		if (dados.current.info.action[type] === undefined) {
			dados.current.info.action[type] = {}
		}
		if (dados.current.info.action[type][name] === undefined) {
			dados.current.info.action[type][name] = {}
		}

		if(name === 'edit') {
			set_notify_responsable_edit(true)
		}

		let today = new Date().toJSON()

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: today,
			execution:	today
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.action[type][name] = aux)

		console.log('dados.current.info.action', dados.current.info.action)

	}
	
	const change_occurrence_action_responsable_name = (e) => {
		const { name, value, dataset } = e.target;
		const { type } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = {}
		}
		if (dados.current.info.action[type] === undefined) {
			dados.current.info.action[type] = {}
		}
		if (dados.current.info.action[type][name] === undefined) {
			dados.current.info.action[type][name] = {}
		}

		let today = new Date().toJSON()

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: '',
			name: value,
			notification: today,
			execution:	today
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.action[type][name] = aux)

		console.log('dados.current.info.action', dados.current.info.action)

	}

	const change_occurrence_client = (e) => {
		const { value } = e.target;

		if (dados.current.info.client === undefined) {
			dados.current.info.client = {}
		}

		let aux_entity = clients_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: ''
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			console.log(aux_entity[0])
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.client = aux)

		console.log('dados.current.info.client', dados.current.info.client)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info, )
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_image = (tD, order, langid) => {

		treeDataImage[order][langid] = tD

		let aux = []
		treeDataImage[order][langid].forEach((el) => {
			dados.current.info.file.image.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.image = aux)
		setTreeDataImage(treeDataImage)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_image = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataImage[order][langid].filter(v => v.id !== id)
					treeDataImage[order][langid] = treeAux
					setTreeDataImage(treeDataImage)

					let aux = []
					dados.current.info.file.image.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.image = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_image = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataImage[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.image.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataImage(treeDataImage)
		set_dados(dados.current.info, )
	}

	const onChangeHandlerFilesFileImage = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_image_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_image_name(aux2)

				let aux_doc = treeDataImage
				if (treeDataImage[order] === undefined)
					treeDataImage[order] = []
				if (treeDataImage[order][langid] === undefined)
					treeDataImage[order][langid] = []
				let i = treeDataImage[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataImage(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_image(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order], )
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'quality')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/quality/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if(dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if(!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}

		if (type === 'editable') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'pdf') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'file_image') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const handleSingleCheckImmediateActionDone = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckOpenACAM = () => {

		if(dados?.current?.info?.action === undefined) {
			set_dados(dados.current.info.action = {})
		}

		if(dados?.current?.info?.action?.analysis === undefined) {
			set_dados(dados.current.info.action.analysis = {})
		}

		if(dados?.current?.info?.action?.analysis?.ac_am === undefined) {
			set_dados(dados.current.info.action.analysis.ac_am = true)
		}
		else {
			set_dados(dados.current.info.action.analysis.ac_am = !dados.current.info.action.analysis.ac_am)
		}

	}

	return isloading ?
		<Loader />
	:
		isRedirect
	?
		<Redirect to={endpoints.list} replace />
	:
		<main>
			<div className={`dash-cards header`}>
				<div className="container">
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
				</div>
			</div>

			<div className={`dash-cards body`}>
				<div className="container">
					<div className="row">
	
						<div className="mb-5 mb-xl-10">
							<div className='card'>

								<div className="card-header border-0 d-flex justify-content-sm-between">
									<div className="card-title m-0">
										<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
									</div>
									<div className="card-toolbar">
										<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
											{
												content_language.length > 1 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item d-none">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
												:
													null
											}
										</ul>
									</div>
								</div>
								<div id="div-content">
									<form id="form" onSubmit={handleSubmit}>

										<div className="card-body border-top p-4">
											<div className='tab-content'>
												{
												content_language.length > 0 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">

																<div className='row mb-4'>
																	<div className="col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_occurrence_type}</label>
																		<select
																			name="occurrence_type"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_occurrence_settings}
																			value={dados?.current?.info?.settings?.occurrence_type !== undefined && dados?.current?.info?.settings?.occurrence_type !== null ? dados.current.info.settings.occurrence_type : ''}
																		>
																			<option value="">{language[lang].field_choose}</option>
																			{
																			occurrence_type.current !== undefined && occurrence_type.current !== null ?
																				occurrence_type.current.map((el_dt, k_dt) => (
																					<option key={k_dt} value={el_dt.id}>
																						{el_dt.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>
																	<div className="col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_occurrence_origin}</label>
																		<select
																			name="occurrence_origin"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_occurrence_settings}
																			value={dados?.current?.info?.settings?.occurrence_origin !== undefined && dados?.current?.info?.settings?.occurrence_origin !== null ? dados.current.info.settings.occurrence_origin : ''}
																		>
																			<option value="">{language[lang].field_choose}</option>
																			{
																			occurrence_origin.current !== undefined && occurrence_origin.current !== null ?
																				occurrence_origin.current.map((el_dt, k_dt) => (
																					<option key={k_dt} value={el_dt.id}>
																						{el_dt.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>
																	{
																	dados?.current?.info?.settings?.occurrence_state !== undefined && dados?.current?.info?.settings?.occurrence_state !== null && 
																	parseInt(dados?.current?.info?.settings?.occurrence_state) === 1 && parseInt(dados.current.info.responsable.aproval.id) === parseInt(getTokenInfo().id) ?
																		<div className="col-2"> 
																			<div className="d-flex">
																				{console.log('dados.current.info.settings.occurrence_state', dados.current.info.settings.occurrence_state)}
																				<div className="ms-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_aproval}</label>
																					<div className="input-group">
																						<label className="switch">
																							<input
																								id={'item-switch-aproval'}
																								name={"aproval"}
																								className=""
																								type="checkbox"
																								value={dados.current.info.settings.occurrence_state !== undefined && parseInt(dados.current.info.settings.occurrence_state) === 3 ? true : false}
																								onChange={handleSingleCheckAproval}
																								defaultChecked={dados.current.info.settings.occurrence_state !== undefined && parseInt(dados.current.info.settings.occurrence_state) === 3 ? true : false}
																							/>
																							<span className="slider" htmlFor={'item-switch-aproval'}></span>
																						</label>
																					</div>
																				</div>
																			</div>
																		</div>
																	:
																		null
																	}
																</div>

																<div className='row mb-4'>
																	<div className="col-4 col-md-2">
																		<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_occurrence_date}</label>
																		<input
																			type="date"
																			name="responsable"
																			data-type="identification"
																			data-type2="execution"
																			defaultValue={
																				dados?.current?.info?.action?.identification?.responsable?.execution !== undefined && dados?.current?.info?.action?.identification?.responsable?.execution !== null && dados.current.info.action.identification.responsable.execution !== '' ? 
																					dados.current.info.action.identification.responsable.execution.split('T')[0]
																				: 
																					''
																				}
																			onChange={(e) => change_occurrence_action_date(e)}
																			className="form-control rounded-0" 
																		/>
																	</div>
																	<div className="col-2">
																		<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_number}</label>
																		<input type="text" name="number" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.number} onChange={(e) => handle_change_info(e)} className="form-control rounded-0 text-end" />
																	</div>
																	<div className="col-12 col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_identification_responsable}</label>
																		<input type="text" name="responsable" data-type="identification" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados?.current?.info?.action?.identification?.responsable?.name !== undefined && dados?.current?.info?.action?.identification?.responsable?.name !== null ? dados.current.info.action.identification.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
																	</div>
																	<div className="col-12 col-md-4 d-none">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_identification_responsable}</label>
																		<select
																			name="responsable"
																			data-type="identification"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_occurrence_action_responsable}
																			value={dados?.current?.info?.action?.identification?.responsable?.id !== undefined && dados?.current?.info?.action?.identification?.responsable?.id !== null ? dados.current.info.action.identification.responsable.id : ''}
																		>
																			<option value="">{language[lang].field_choose_responsable}</option>
																			{
																			entities_list.current !== undefined && entities_list.current !== null ?
																				entities_list.current.map((el_el, k_el) => (
																					<option key={k_el} value={el_el.id}>
																						{el_el.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>
																</div>

																<div className='row mb-4'>
																	<div className="col-2 d-none">
																		<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_tag}</label>
																		<input type="text" name="tag" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.tag} onChange={(e) => handle_change_info(e)} className="form-control rounded-0" />
																	</div>
																	<div className="col-6">
																		<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																		<input type="text" name="title" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.title, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" required={el_lang.id === '1' ? 'required' : ''} />
																	</div>

																	{
																	el_lang.id === '1' || true ?
																		<div className="col-2"> 
																			<div className="d-flex">
																				<div className="mb-3 d-none">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																					<div className="input-group">
																						<label className="switch">
																							<input
																								id={'item-switch-active'}
																								name={"active"}
																								className=""
																								type="checkbox"
																								value={dados.current.info.active}
																								onChange={handleSingleCheckActive}
																								defaultChecked={dados.current.info.active}
																							/>
																							<span className="slider" htmlFor={'item-switch-active'}></span>
																						</label>
																					</div>
																				</div>

																				<div className="ms-3 d-none">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_avaiable}</label>
																					<div className="input-group">
																						<label className="switch">
																							<input
																								id={'item-switch-avaiable'}
																								name={"avaiable"}
																								className=""
																								type="checkbox"
																								value={dados.current.info.avaiable}
																								onChange={handleSingleCheckAvaiable}
																								defaultChecked={dados.current.info.avaiable}
																							/>
																							<span className="slider" htmlFor={'item-switch-avaiable'}></span>
																						</label>
																					</div>
																				</div>
																				
																			</div>
																		</div>
																	:
																		null
																	}
																</div>

																<div className="row mb-4">
																	<div className="col-6">
																		<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																		<textarea type="text" rows="4" name="description" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.description, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" />
																	</div>
																</div>
																
																{
																dados?.current?.info?.settings?.occurrence_origin !== undefined && (parseInt(dados.current.info.settings.occurrence_origin) === 23 || parseInt(dados.current.info.settings.occurrence_origin) === 25) || true ?
																	<div className='row mb-4'>
																		<div className="col-6 col-md-4">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_product}</label>
																			<input type="text" name="occurrence_product" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.settings.occurrence_product} onChange={(e) => change_occurrence_settings(e)} className="form-control rounded-0" />
																		</div>
																		<div className="col-6 col-md-4">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_project}</label>
																			<input type="text" name="occurrence_project" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.settings.occurrence_project} onChange={(e) => change_occurrence_settings(e)} className="form-control rounded-0" />
																		</div>
																		<div className="col-6 col-md-4">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_department}</label>
																			<select
																			name="occurrence_department"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_occurrence_settings}
																			value={dados?.current?.info?.settings?.occurrence_department !== undefined && dados?.current?.info?.settings?.occurrence_department !== null ? dados.current.info.settings.occurrence_department : ''}
																		>
																			<option value="">{language[lang].field_choose_department}</option>
																			{
																			departamentos_list.current !== undefined && departamentos_list.current !== null ?
																				departamentos_list.current.map((el_el, k_el) => (
																					<option key={k_el} value={el_el.id}>
																						{el_el.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																		</div>
																	</div>
																:
																	null
																}

																{
																dados?.current?.info?.settings?.occurrence_origin !== undefined && (parseInt(dados.current.info.settings.occurrence_origin) === 24) ?
																	<div className='row mb-4'>
																		<div className="col-12 col-md-4">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_client}</label>
																			<select
																				name="client"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={change_occurrence_client}
																				value={dados?.current?.info?.client?.id !== undefined && dados?.current?.info?.client?.id !== null ? dados.current.info.client?.id : ''}
																			>
																				<option value="">{language[lang].field_choose_client}</option>
																				{
																				clients_list.current !== undefined && clients_list.current !== null ?
																					clients_list.current.map((el_el, k_el) => (
																						<option key={k_el} value={el_el.id}>
																							{el_el.label}
																						</option>
																					))
																				:
																					null
																				}
																			</select>
																		</div>
																	</div>
																:
																	null
																}

																<div className="row mb-4">
																	<div className="col-12 col-md-6">
																		<div className="div-doc">
																			<label className="col-form-label fw-bold fs-6">{language[lang].field_occurrence_image}</label>

																			<div className="dropzone-panel mb-lg-0 mb-2">
																				<div className="div-form-input col-12 custom-file">
																					<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-image-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																					<input
																						id={"input-files-image-" + 0 + '-' + el_lang.id}
																						type="file"
																						// accept="application/pdf"
																						data-order={0}
																						data-langid={el_lang.id}
																						data-lang={el_lang.code}
																						data-type={'doc'}
																						className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																						onChange={onChangeHandlerFilesFileImage}
																						multiple
																					/>
																				</div>
																			</div>

																			<div className="row">
																				{
																					treeDataImage[0] !== undefined && treeDataImage[0][el_lang.id] !== undefined ?
																						<SortableTree
																							isVirtualized={false}
																							treeData={treeDataImage[0][el_lang.id]}
																							maxDepth={1}
																							canDrag={false}
																							//onChange={() => console.log('onChange')}
																							onChange={treeDataImage => handle_change_tree_image(treeDataImage, 0, el_lang.id)}
																							getNodeKey={({ node }) => node.id}
																							generateNodeProps={extendedNode => ({
																								title: (
																									<>
																										{extendedNode.node.title}
																										<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_image} />
																									</>
																								),
																								buttons: [
																									<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																									<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																									<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																									<button type="button" onClick={() => remove_element_tree_image(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																								],
																							})}
																						/>
																						:
																						''
																				}
																			</div>
																		</div>
																	</div>
																	<div className="col-12 col-md-6 d-none">
																		<div className="div-doc">
																			<label className="col-form-label fw-bold fs-6">{language[lang].editable_documents}</label>

																			<div className="dropzone-panel mb-lg-0 mb-2">
																				<div className="div-form-input col-12 custom-file">
																					<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-editable-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																					<input
																						id={"input-files-editable-" + 0 + '-' + el_lang.id}
																						type="file"
																						// accept="application/pdf"
																						data-order={0}
																						data-langid={el_lang.id}
																						data-lang={el_lang.code}
																						data-type={'doc'}
																						className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																						onChange={onChangeHandlerFilesEditable}
																						multiple
																					/>
																				</div>
																			</div>

																			<div className="row">
																				{
																					treeDataEditable[0] !== undefined && treeDataEditable[0][el_lang.id] !== undefined ?
																						<SortableTree
																							isVirtualized={false}
																							treeData={treeDataEditable[0][el_lang.id]}
																							maxDepth={1}
																							canDrag={false}
																							//onChange={() => console.log('onChange')}
																							onChange={treeDataEditable => handle_change_tree_editable(treeDataEditable, 0, el_lang.id)}
																							getNodeKey={({ node }) => node.id}
																							generateNodeProps={extendedNode => ({
																								title: (
																									<>
																										{extendedNode.node.title}
																										<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_editable} />
																									</>
																								),
																								buttons: [
																									<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																									<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																									<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																									<button type="button" onClick={() => remove_element_tree_editable(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																								],
																							})}
																						/>
																						:
																						''
																				}
																			</div>
																		</div>
																	</div>
																	<div className="col-12 col-md-6 d-none">
																		<div className="div-doc">
																			<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																			<div className="dropzone-panel mb-lg-0 mb-2">
																				<div className="div-form-input col-12 custom-file">
																					<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																					<input
																						id={"input-files-pdf-" + 0 + '-' + el_lang.id}
																						type="file"
																						accept="application/pdf"
																						data-order={0}
																						data-langid={el_lang.id}
																						data-lang={el_lang.code}
																						data-type={'doc'}
																						className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																						onChange={onChangeHandlerFilesPDF}
																						multiple
																					/>
																				</div>
																			</div>

																			<div className="row">
																				{
																					treeDataPDF[0] !== undefined && treeDataPDF[0][el_lang.id] !== undefined ?
																						<SortableTree
																							isVirtualized={false}
																							treeData={treeDataPDF[0][el_lang.id]}
																							maxDepth={1}
																							canDrag={false}
																							//onChange={() => console.log('onChange')}
																							onChange={treeDataPDF => handle_change_tree_pdf(treeDataPDF, 0, el_lang.id)}
																							getNodeKey={({ node }) => node.id}
																							generateNodeProps={extendedNode => ({
																								title: (
																									<>
																										<span>{extendedNode.node.title}</span>
																										<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf} />
																									</>
																								),
																								buttons: [
																									<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																									<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																									<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																									<button type="button" onClick={() => remove_element_tree_pdf(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																								],
																							})}
																						/>
																						:
																						''
																				}
																			</div>
																		</div>
																	</div>
																</div>
																
															</div>
														)
													})
												:
													null
												}
											</div>
										</div>

										<div className="card-header border-0 d-flex justify-content-sm-between">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].label_treatment}</h3>
											</div>
										</div>

										<div className="card-body border-top p-4">

											<div className="row mb-4">
												<div className="card-title m-0">
													<label className={"fs-5 fw-bold mb-2"}>{language[lang].label_immediate_action}</label>
												</div>
												
												<div className="col-12 col-md-6 mb-3">
													<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_immediate_action_description}</label>
													<textarea type="text" rows="4" name="description" data-type='immediate_action' defaultValue={dados?.current?.info?.action?.immediate_action?.description !== undefined ? dados.current.info.action.immediate_action.description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
												</div>

												<div className="col-12 col-md-6 mb-3">
													<div className='row'>
														<div className="col-12 col-md-6">
															<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_execution}</label>
															<input type="text" name="responsable" data-type="immediate_action" defaultValue={dados?.current?.info?.action?.immediate_action?.responsable?.name !== undefined && dados?.current?.info?.action?.immediate_action?.responsable?.name !== null ? dados.current.info.action.immediate_action.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
														</div>

														<div className="col-12 col-md-6 mb-3 d-none">
															<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_execution}</label>
															<select
																name="responsable"
																data-type="immediate_action"
																className="form-select form-control mb-2 rounded-0"
																onChange={change_occurrence_action_responsable}
																value={dados?.current?.info?.action?.immediate_action?.responsable?.id !== undefined && dados?.current?.info?.action?.immediate_action?.responsable?.id !== null ? dados.current.info.action.immediate_action.responsable.id : ''}
															>
																<option value="">{language[lang].field_choose_responsable}</option>
																{
																entities_list.current !== undefined && entities_list.current !== null ?
																	entities_list.current.map((el_el, k_el) => (
																		<option key={k_el} value={el_el.id}>
																			{el_el.label}
																		</option>
																	))
																:
																	null
																}
															</select>
															<label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
															<div className="input-group">
																<input 
																	type="text" 
																	name="cost" 
																	data-type='immediate_action'
																	defaultValue={dados?.current?.info?.action?.immediate_action?.cost !== undefined ? dados.current.info.action.immediate_action.cost : ''} 
																	onChange={(e) => change_occurrence_action(e)}
																	className="form-control rounded-0 text-end" 
																/>
																<span className='input-group-text rounded-0'>&euro;</span>
															</div>
														</div>

														<div className="col-6 col-md-4 mb-3">
															<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_execution}</label>
															<input
																type="date"
																name="responsable"
																data-type="immediate_action"
																data-type2="execution"
																defaultValue={
																	dados?.current?.info?.action?.immediate_action?.responsable?.execution !== undefined && dados?.current?.info?.action?.immediate_action?.responsable?.execution !== null && dados.current.info.action.immediate_action.responsable.execution !== '' ? 
																		dados.current.info.action.immediate_action.responsable.execution.split('T')[0]
																	: 
																		''
																	}
																onChange={(e) => change_occurrence_action_date(e)}
																className="form-control rounded-0" 
															/>
														</div>

													</div>
												</div>
											</div>

										</div>

										<div className="card-body border-top p-4">

											<div className="row mb-4">
												<div className="card-title m-0">
													<label className={"fs-5 fw-bold mb-2"}>{language[lang].label_analysis}</label>
												</div>
												
												<div className="col-12 col-md-6 mb-3">
													<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_analysis_cause_description}</label>
													<textarea type="text" rows="4" name="cause_description" data-type='analysis' defaultValue={dados?.current?.info?.action?.analysis?.cause_description !== undefined ? dados.current.info.action.analysis.cause_description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
												</div>
												
												<div className="col-12 col-md-6 mb-3">
													<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_analysis_cause_non_detection_description}</label>
													<textarea type="text" rows="4" name="cause_non_detection_description" data-type='analysis' defaultValue={dados?.current?.info?.action?.analysis?.cause_non_detection_description !== undefined ? dados.current.info.action.analysis.cause_non_detection_description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
												</div>

												<div className="col-12 mb-3">
													<div className='row'>

														<div className="col-6 col-md-4">
															<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_analysis}</label>
															<input type="text" name="responsable" data-type="analysis" defaultValue={dados?.current?.info?.action?.analysis?.responsable?.name !== undefined && dados?.current?.info?.action?.analysis?.responsable?.name !== null ? dados.current.info.action.analysis.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
														</div>

														<div className="col-6 col-md-4 mb-3 d-none">
															<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_analysis}</label>
															<select
																name="responsable"
																data-type="analysis"
																className="form-select form-control mb-4 mb-lg-0 rounded-0"
																onChange={change_occurrence_action_responsable}
																value={dados?.current?.info?.action?.analysis?.responsable?.id !== undefined && dados?.current?.info?.action?.analysis?.responsable?.id !== null ? dados.current.info.action.analysis.responsable.id : ''}
															>
																<option value="">{language[lang].field_choose_responsable}</option>
																{
																entities_list.current !== undefined && entities_list.current !== null ?
																	entities_list.current.map((el_el, k_el) => (
																		<option key={k_el} value={el_el.id}>
																			{el_el.label}
																		</option>
																	))
																:
																	null
																}
															</select>
														</div>

														<div className="col-4 col-md-2 mb-3">
															<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_analysis}</label>
															<input
																type="date"
																name="responsable"
																data-type="analysis"
																data-type2="deadline"
																defaultValue={
																	dados?.current?.info?.action?.analysis?.responsable?.deadline !== undefined && dados?.current?.info?.action?.analysis?.responsable?.deadline !== null && dados.current.info.action.analysis.responsable.deadline !== '' ? 
																		dados.current.info.action.analysis.responsable.deadline.split('T')[0]
																	: 
																		''
																	}
																onChange={(e) => change_occurrence_action_date(e)}
																className="form-control rounded-0" 
															/>
														</div>

														<div className="col-2 col-md-2 mb-3">
														
															<label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
															<div className="input-group">
																<input 
																	type="text" 
																	name="cost" 
																	data-type='analysis'
																	defaultValue={dados?.current?.info?.action?.analysis?.cost !== undefined ? dados.current.info.action.analysis.cost : ''} 
																	onChange={(e) => change_occurrence_action(e)}
																	className="form-control rounded-0 text-end" 
																/>
																<span className='input-group-text rounded-0'>&euro;</span>
															</div>
														</div>

														<div className="col-2"> 
															<div className="d-flex">
																<div className="ms-3 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_open_acam}</label>
																	<div className="input-group">
																		<label className="switch">
																			<input
																				id={'item-switch-open-acam'}
																				name={"ac_am"}
																				className=""
																				type="checkbox"
																				value={dados?.current?.info?.action?.analysis?.ac_am !== undefined ? dados.current.info.action.analysis.ac_am : false}
																				onChange={handleSingleCheckOpenACAM}
																				defaultChecked={dados?.current?.info?.action?.analysis?.ac_am !== undefined ? dados.current.info.action.analysis.ac_am : false}
																			/>
																			<span className="slider" htmlFor={'item-switch-open-acam'}></span>
																		</label>
																	</div>
																</div>
																
															</div>
														</div>

													</div>
												</div>
											</div>

										</div>

										{
										dados?.current?.info?.action?.analysis?.ac_am !== undefined && dados.current.info.action.analysis.ac_am === true ?
											<div className="card-body border-top p-4">

												<div className="row mb-4">
													<div className="card-title m-0">
														<label className={"fs-5 fw-bold mb-2"}>{language[lang].label_improvement}</label>
													</div>
		
													<div className="col-6 col-md-3 mb-3">
														<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_ac_am}</label>
														<select
															name="type"
															data-type="improvement"
															className="form-select form-control mb-4 mb-lg-0 rounded-0"
															onChange={change_occurrence_action}
															value={dados?.current?.info?.action?.improvement?.type !== undefined && dados?.current?.info?.action?.improvement?.type !== null ? dados.current.info.action.improvement.type : ''}
														>
															<option value="">{language[lang].field_choose}</option>
															<option value="AC">{language[lang].field_ac}</option>
															<option value="AM">{language[lang].field_am}</option>
														</select>
													</div>

													<div className="col-12"></div>
													
													<div className="col-12 col-md-6 mb-3">
														<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_improvement_description}</label>
														<textarea type="text" rows="4" name="description" data-type='improvement' defaultValue={dados?.current?.info?.action?.improvement?.description !== undefined ? dados.current.info.action.improvement.description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
													</div>

													<div className="col-12 col-md-6 mb-3">
														<div className='row'>

															<div className="col-12 col-md-6">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_execution}</label>
																<input type="text" name="responsable" data-type="improvement" defaultValue={dados?.current?.info?.action?.improvement?.responsable?.name !== undefined && dados?.current?.info?.action?.improvement?.responsable?.name !== null ? dados.current.info.action.improvement.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
															</div>

															<div className="col-12 col-md-6 mb-3 d-none">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_execution}</label>
																<select
																	name="responsable"
																	data-type="improvement"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_occurrence_action_responsable}
																	value={dados?.current?.info?.action?.improvement?.responsable?.id !== undefined && dados?.current?.info?.action?.improvement?.responsable?.id !== null ? dados.current.info.action.improvement.responsable.id : ''}
																>
																	<option value="">{language[lang].field_choose_responsable}</option>
																	{
																	entities_list.current !== undefined && entities_list.current !== null ?
																		entities_list.current.map((el_el, k_el) => (
																			<option key={k_el} value={el_el.id}>
																				{el_el.label}
																			</option>
																		))
																	:
																		null
																	}
																</select>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_deadline}</label>
																<input
																	type="date"
																	name="responsable"
																	data-type="improvement"
																	data-type2="deadline"
																	defaultValue={
																		dados?.current?.info?.action?.improvement?.responsable?.deadline !== undefined && dados?.current?.info?.action?.improvement?.responsable?.deadline !== null && dados.current.info.action.improvement.responsable.deadline !== '' ? 
																			dados.current.info.action.improvement.responsable.deadline.split('T')[0]
																		: 
																			''
																		}
																	onChange={(e) => change_occurrence_action_date(e)}
																	className="form-control rounded-0" 
																/>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_execution}</label>
																<input
																	type="date"
																	name="responsable"
																	data-type="improvement"
																	data-type2="execution"
																	defaultValue={
																		dados?.current?.info?.action?.improvement?.responsable?.execution !== undefined && dados?.current?.info?.action?.improvement?.responsable?.execution !== null && dados.current.info.action.improvement.responsable.execution !== '' ? 
																			dados.current.info.action.improvement.responsable.execution.split('T')[0]
																		: 
																			''
																		}
																	onChange={(e) => change_occurrence_action_date(e)}
																	className="form-control rounded-0" 
																/>
															</div>
															<div className="col-6 col-md-4 mb-3">

																<label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
																<div className="input-group">
																	<input 
																		type="text" 
																		name="cost" 
																		data-type='improvement'
																		defaultValue={dados?.current?.info?.action?.improvement?.cost !== undefined ? dados.current.info.action.improvement.cost : ''} 
																		onChange={(e) => change_occurrence_action(e)}
																		className="form-control rounded-0 text-end" 
																	/>
																	<span className='input-group-text rounded-0'>&euro;</span>
																</div>
															</div>

														</div>
													</div>
												</div>

											</div>
										:
											null
										}

										{
										dados?.current?.info?.action?.analysis?.ac_am !== undefined && dados.current.info.action.analysis.ac_am === true ?
											<div className="card-header border-0 d-flex justify-content-sm-between">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].label_evaluation}</h3>
												</div>
											</div>
										:
											null
										}

										{
										dados?.current?.info?.action?.analysis?.ac_am !== undefined && dados.current.info.action.analysis.ac_am === true ?
											<div className="card-body border-top p-4">

												<div className="row mb-4">
													<div className="card-title m-0">
														<label className={"fs-5 fw-bold mb-2"}>{language[lang].label_effectiveness}</label>
													</div>

													<div className="col-12 col-md-6 mb-3">
														<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_effectiveness_description}</label>
														<textarea type="text" rows="4" name="description" data-type='effectiveness' defaultValue={dados?.current?.info?.action?.effectiveness?.description !== undefined ? dados.current.info.action.effectiveness.description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
													</div>
													
													<div className="col-6 col-md-3 mb- d-none">
														<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_effectiveness}</label>
														<select
															name="value"
															data-type="effectiveness"
															className="form-select form-control mb-4 mb-lg-0 rounded-0"
															onChange={change_occurrence_action}
															value={dados?.current?.info?.action?.effectiveness?.value !== undefined && dados?.current?.info?.action?.effectiveness?.value !== null ? dados.current.info.action.effectiveness.value : ''}
														>
															<option value="">{language[lang].field_choose}</option>
															<option value="1">{language[lang].field_yes}</option>
															<option value="0">{language[lang].field_no}</option>
														</select>
													</div>

													<div className="col-6 col-md-6 mb-3">
														<div className='row'>
															
															<div className="col-12 col-md-6 d-none">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_execution}</label>
																<input type="text" name="responsable" data-type="effectiveness" defaultValue={dados?.current?.info?.action?.effectiveness?.responsable?.name !== undefined && dados?.current?.info?.action?.effectiveness?.responsable?.name !== null ? dados.current.info.action.effectiveness.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
															</div>

															<div className="col-12 col-md-6 mb-3 d-none">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																<select
																	name="responsable"
																	data-type="effectiveness"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_occurrence_action_responsable}
																	value={dados?.current?.info?.action?.effectiveness?.responsable?.id !== undefined && dados?.current?.info?.action?.effectiveness?.responsable?.id !== null ? dados.current.info.action.effectiveness.responsable.id : ''}
																>
																	<option value="">{language[lang].field_choose_responsable}</option>
																	{
																	entities_list.current !== undefined && entities_list.current !== null ?
																		entities_list.current.map((el_el, k_el) => (
																			<option key={k_el} value={el_el.id}>
																				{el_el.label}
																			</option>
																		))
																	:
																		null
																	}
																</select>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_deadline_evaluation}</label>
																<input
																	type="date"
																	name="responsable"
																	data-type="effectiveness"
																	data-type2="deadline"
																	defaultValue={
																		dados?.current?.info?.action?.effectiveness?.responsable?.deadline !== undefined && dados?.current?.info?.action?.effectiveness?.responsable?.deadline !== null && dados.current.info.action.effectiveness.responsable.deadline !== '' ? 
																			dados.current.info.action.effectiveness.responsable.deadline.split('T')[0]
																		: 
																			''
																		}
																	onChange={(e) => change_occurrence_action_date(e)}
																	className="form-control rounded-0" 
																/>
															</div>

														</div>
													</div>
												</div>

											</div>
										:
											null
										}

										{
										dados?.current?.info?.action?.analysis?.ac_am !== undefined && dados.current.info.action.analysis.ac_am === true ?
											<div className="card-body border-top p-4">

												<div className="row mb-4">
													<div className="card-title m-0">
														<label className={"fs-5 fw-bold mb-2"}>{language[lang].label_results}</label>
													</div>

													<div className="col-12 col-md-6 mb-3">
														<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description}</label>
														<textarea type="text" rows="4" name="description" data-type='results' defaultValue={dados?.current?.info?.action?.results?.description !== undefined ? dados.current.info.action.results.description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
													</div>
													
													<div className="col-12 col-md-6 mb-3">
														<div className='row'>
															
															<div className="col-12 col-md-6 mb-3">
																<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_effectiveness}</label>
																<select
																	name="value"
																	data-type="results"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_occurrence_action}
																	value={dados?.current?.info?.action?.results?.value !== undefined && dados?.current?.info?.action?.results?.value !== null ? dados.current.info.action.results.value : ''}
																>
																	<option value="">{language[lang].field_choose}</option>
																	<option value="1">{language[lang].field_yes}</option>
																	<option value="0">{language[lang].field_no}</option>
																</select>
															</div>
													
															{
															dados?.current?.info?.action?.results?.value !== undefined && dados?.current?.info?.action?.results?.value !== null && parseInt(dados.current.info.action.results.value) === 0 ?
																<div className="col-12 col-md-6 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_new_occurrence}</label>
																	<input type="text" name="new_occurrence" data-type="results" defaultValue={dados?.current?.info?.action?.results?.new_occurrence !== undefined && dados?.current?.info?.action?.results?.new_occurrence !== null ? dados.current.info.action.results.new_occurrence : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
																</div>
															:
																<div className="col-12 col-md-6 mb-3"></div>
															}
														
															<div className="col-12 col-md-6 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_evaluation}</label>
																<input type="text" name="responsable" data-type="results" defaultValue={dados?.current?.info?.action?.results?.responsable?.name !== undefined && dados?.current?.info?.action?.results?.responsable?.name !== null ? dados.current.info.action.results.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
															</div>

															<div className="col-12 col-md-6 mb-3 d-none">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_evaluation}</label>
																<select
																	name="responsable"
																	data-type="results"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_occurrence_action_responsable}
																	value={dados?.current?.info?.action?.results?.responsable?.id !== undefined && dados?.current?.info?.action?.results?.responsable?.id !== null ? dados.current.info.action.results.responsable.id : ''}
																>
																	<option value="">{language[lang].field_choose_responsable}</option>
																	{
																	entities_list.current !== undefined && entities_list.current !== null ?
																		entities_list.current.map((el_el, k_el) => (
																			<option key={k_el} value={el_el.id}>
																				{el_el.label}
																			</option>
																		))
																	:
																		null
																	}
																</select>
															</div>

															<div className="col-12 col-md-6 mb-3">
																<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_evaluation}</label>
																<input
																	type="date"
																	name="responsable"
																	data-type="results"
																	data-type2="execution"
																	defaultValue={
																		dados?.current?.info?.action?.results?.responsable?.execution !== undefined && dados?.current?.info?.action?.results?.responsable?.execution !== null && dados.current.info.action.results.responsable.execution !== '' ? 
																			dados.current.info.action.results.responsable.execution.split('T')[0]
																		: 
																			''
																		}
																	onChange={(e) => change_occurrence_action_date(e)}
																	className="form-control rounded-0" 
																/>
															</div>

														</div>
													</div>
												</div>

											</div>
										:
											null
										}

										{
										dados?.current?.info?.action?.analysis?.ac_am !== undefined && dados.current.info.action.analysis.ac_am === true ?
											<div className="card-body border-top p-4">

												<div className="row mb-4">
													<div className="card-title m-0">
														<label className={"fs-5 fw-bold mb-2"}>{language[lang].label_closing}</label>
													</div>
													
													<div className="col-12 col-md-6 mb-3">
														<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_closing_description}</label>
														<textarea type="text" rows="4" name="description" data-type='closing' defaultValue={dados?.current?.info?.action?.closing?.description !== undefined ? dados.current.info.action.closing.description : ''} onChange={(e) => change_occurrence_action(e)} className="form-control rounded-0" />
													</div>

													<div className="col-12 col-md-6 mb-3">
														<div className='row'>

															<div className="col-12 col-md-6 mb.3">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable_execution}</label>
																<input type="text" name="responsable" data-type="closing" defaultValue={dados?.current?.info?.action?.closing?.responsable?.name !== undefined && dados?.current?.info?.action?.closing?.responsable?.name !== null ? dados.current.info.action.closing.responsable.name : ''} onChange={(e) => change_occurrence_action_responsable_name(e)} className="form-control rounded-0" />
															</div>

															<div className="col-12 col-md-6 mb-3 d-none">
																<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																<select
																	name="responsable"
																	data-type="closing"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_occurrence_action_responsable}
																	value={dados?.current?.info?.action?.closing?.responsable?.id !== undefined && dados?.current?.info?.action?.closing?.responsable?.id !== null ? dados.current.info.action.closing.responsable.id : ''}
																>
																	<option value="">{language[lang].field_choose_responsable}</option>
																	{
																	entities_list.current !== undefined && entities_list.current !== null ?
																		entities_list.current.map((el_el, k_el) => (
																			<option key={k_el} value={el_el.id}>
																				{el_el.label}
																			</option>
																		))
																	:
																		null
																	}
																</select>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date}</label>
																<input
																	type="date"
																	name="responsable"
																	data-type="closing"
																	data-type2="deadline"
																	defaultValue={
																		dados?.current?.info?.action?.closing?.responsable?.deadline !== undefined && dados?.current?.info?.action?.closing?.responsable?.deadline !== null && dados.current.info.action.closing.responsable.deadline !== '' ? 
																			dados.current.info.action.closing.responsable.deadline.split('T')[0]
																		: 
																			''
																		}
																	onChange={(e) => change_occurrence_action_date(e)}
																	className="form-control rounded-0" 
																/>
															</div>

														</div>
													</div>
												</div>

											</div>
										:
											null
										}

									</form>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>

			<div className={'dash-cards footer'}>
				<nav className="navbar bottom-navbar navbar-light">
					<div className="navbar-footer">
						<ul className="navbar-nav float-left"></ul>
						<ul className="navbar-nav float-right">
							<li className="nav-item">
								<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
								</Link>
							</li>
							<li className={"nav-item " + show_delete_button}>
								<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
									<i className="bi bi-trash3 me-2"></i>
									<span>{language[lang].delete}</span>
								</button>
							</li>
							<li className="nav-item">
								<button type="submit" form="form" className="nav-link">
									<i className="bi bi-floppy me-2"></i>
									<span>{language[lang].save}</span>
								</button>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</main>
}
